import * as React from 'react'
import '../../css/page/dropdown.css'
import classNames from 'classnames';

let current_operation_instance = null
// 下拉组件
export class Dropdown extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isShow: false,
      _instance_id: Date.now() + Math.random()
    }
    this.hideDropList = this.hideDropList.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleOtherClick = this.handleOtherClick.bind(this)
    this.dropdownTop = -1
  }

  componentDidMount() {
    window.addEventListener('click', this.hideDropList, false)
    window.addEventListener('click_dropdown', this.handleOtherClick )
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.hideDropList, false)
    window.removeEventListener('click_dropdown', this.handleOtherClick)
  }

  hideDropList() {
    setTimeout(() => {
      this.setState({
        isShow: false,
      })
    },50)
  }
  handleOtherClick() {
    if (current_operation_instance !== this.state._instance_id) {
      this.setState({
        isShow: false,
      })
    }
  }

  handleClick () {
    const { isShow } = this.state;
    current_operation_instance = this.state._instance_id
    this.setState({
      isShow: !isShow
    });
    window.dispatchEvent(new Event('click_dropdown'))
  }

  render () {
    // 下拉框是否出现在顶部
    const isDropDownTop = window.innerHeight - 100 < this.dropdownTop
    const dropListValue =  ((this.props.droplist || {}).props || {}).children || []
    if (dropListValue && Array.isArray(dropListValue) && !dropListValue.find(item => item)) {
      // 没有子菜单了，也不显示入口
      return null
    }
    const { isShow } = this.state;
    return <div>
      <div className={'dropdown-label'} onClick={(e) => {
        if (e.target && e.target.getBoundingClientRect) {
          this.dropdownTop = e.target.getBoundingClientRect().top
        }
        e.stopPropagation()
        this.handleClick()
      }}>
        {this.props.children}
      </div>
      {isShow && <div className={classNames('dropdown-drop-list-wrap', isDropDownTop ? 'dropdown-drop-list-wrap__top': '')}>
        <div className={'dropdown-drop-list'}>
          {this.props.droplist}
        </div>
      </div>}
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdown/index.js